import { FulfillmentGroupPickStatus } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { Order } from "@redotech/redo-model/order";
import type { MerchantAppReturn } from "@redotech/redo-model/return";
import {
  getEmailScope,
  type SupportTicketCollectionFilter,
} from "./support-ticket-collection-scope";

export type OrderWithPickStatus = Order & {
  pickStatuses: FulfillmentGroupPickStatus[];
  storeUrl?: string;
};

export interface SupportTicketRelatedRecordsApi {
  getOrdersByEmail(
    teamId: string,
    email: string,
    options?: { limit?: number },
  ): Promise<OrderWithPickStatus[]>;
  getReturnsByEmail(
    teamId: string,
    email: string,
    options?: { limit?: number },
  ): Promise<MerchantAppReturn[]>;
}

export function getTeamIdScope(
  filters: readonly {
    field: readonly (string | number)[] | string;
    operator: string;
    value?: unknown;
  }[],
): string | null {
  const filter = filters.find(
    (f) => (Array.isArray(f.field) ? f.field[0] : f.field) === "team",
  );
  if (filter?.operator !== "eq" || typeof filter.value !== "string") {
    return null;
  }
  return filter.value;
}

export function getEmailFilterValue(
  filters: readonly SupportTicketCollectionFilter[],
  fieldName: string,
  validateEmail: boolean,
): string | null {
  return getEmailScope(filters, fieldName, validateEmail);
}
